export const initState = {
  list: [],
  counts: {},
  loading: false,
  saving: false,
  error: null,
};

export const types = {
  // List
  GET_TEAMS_REQUEST: "TEAMS/GET_REQUEST",
  GET_TEAMS_SUCCESS: "TEAMS/GET_SUCCESS",
  GET_TEAMS_FAILED: "TEAMS/GET_FAILED",

  // Create
  CREATE_TEAM_REQUEST: "TEAMS/CREATE_REQUEST",
  CREATE_TEAM_SUCCESS: "TEAMS/CREATE_SUCCESS",
  CREATE_TEAM_FAILED: "TEAMS/CREATE_FAILED",

  // Update (rename / recolor)
  UPDATE_TEAM_REQUEST: "TEAMS/UPDATE_REQUEST",
  UPDATE_TEAM_SUCCESS: "TEAMS/UPDATE_SUCCESS",
  UPDATE_TEAM_FAILED: "TEAMS/UPDATE_FAILED",

  // Archive (soft-delete)
  ARCHIVE_TEAM_REQUEST: "TEAMS/ARCHIVE_REQUEST",
  ARCHIVE_TEAM_SUCCESS: "TEAMS/ARCHIVE_SUCCESS",
  ARCHIVE_TEAM_FAILED: "TEAMS/ARCHIVE_FAILED",

  // Single-user assign (the dropdown). Backend roundtrip handled in the
  // consumer; reducer just bumps counts and triggers a getCompanyUsers
  // refresh in the consumer/saga so user.team flows back through Redux.
  ASSIGN_USER_TEAM_REQUEST: "TEAMS/ASSIGN_USER_REQUEST",
  ASSIGN_USER_TEAM_SUCCESS: "TEAMS/ASSIGN_USER_SUCCESS",
  ASSIGN_USER_TEAM_FAILED: "TEAMS/ASSIGN_USER_FAILED",
};
